module.exports = __webpack_public_path__ + "assets/SquareBy4Pt.c684d16cbbb0a92220cf5b02d5e8c46d.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/SquareBy4Pt.gmt
// module id = 997
// module chunks = 0